import React from "react"

const SvgPlay = (props) => (
  <svg viewBox="0 0 18 18" {...props}>
    <path d="M0 0l18 9-18 9z" fillRule="evenodd" />
  </svg>
)

export default SvgPlay
